export default __webpack_public_path__ + "static/media/walletconnect-circle.a4166a89.svg";